(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.DryingController = (function(superClass) {
    extend(DryingController, superClass);

    function DryingController(scope, transitions, modal, http, service) {
      this.scope = scope;
      this.transitions = transitions;
      this.modal = modal;
      this.http = http;
      this.service = service;
      this.calculatePowerSourceAmount = bind(this.calculatePowerSourceAmount, this);
      this.autoSetPowerSourceAmount = bind(this.autoSetPowerSourceAmount, this);
      this.autoSetPowerSource = bind(this.autoSetPowerSource, this);
      DryingController.__super__.constructor.apply(this, arguments);
      this.uoms = {};
      this.fieldArea = 0;
      this.dryingSystems = {
        'In bin - combination high temperature and air': {
          type: 'stirred',
          source: 'Propane, LPG'
        },
        'In bin - natural air/air only': {
          type: 'natural',
          source: 'Electricity - Grid'
        },
        'In bin - low temperature': {
          type: 'low',
          source: 'Electricity - Grid'
        },
        'In bin - high temperature-air recirculation - continuous flow/mixed flow': {
          type: 'recirculating',
          source: 'Propane, LPG'
        },
        'In bin - high temperature layered batch-in-bin or bin with stirring device': {
          type: 'recirculating',
          source: 'Propane, LPG'
        },
        'Batch Dryer - high temperature-no air recirculation (Continuous flow dryer)': {
          type: 'no-recirculating',
          source: 'Propane, LPG'
        },
        'Batch Dryer - high temperature-no air recirculation (Automatic batch dryer)': {
          type: 'no-recirculating',
          source: 'Propane, LPG'
        },
        'Batch Dryer PTO type - high temperature-no air recirculation': {
          type: 'no-recirculating',
          source: 'Propane, LPG'
        },
        'Commercially dried by buyer': {
          type: 'no-recirculating',
          source: 'Propane, LPG'
        }
      };
      this.service.onDataLoaded(this.scope, (function(_this) {
        return function() {
          _this.http.get("/backend/grower/fieldprint/power-source-uoms/" + _this.service.crop).then(function(response) {
            return _this.uoms = response.data;
          });
          return _this.http.get("/backend/grower/fieldprint/field-area/" + _this.service.field).then(function(response) {
            _this.fieldArea = response.data;
            _this.scope.$watch('service.fpcResult.data.moisture_difference', function() {
              return _this.autoSetPowerSourceAmount();
            });
            _this.scope.$watch('service.fpcResult.data.power_source', function(newValue, oldValue) {
              return _this.autoSetPowerSourceAmount();
            });
            _this.scope.$watch('service.fpcResult.data.dryland_projected', function() {
              return _this.autoSetPowerSourceAmount();
            });
            _this.scope.$watch('service.fpcResult.data.dryland_actual', function() {
              return _this.autoSetPowerSourceAmount();
            });
            _this.scope.$watch('service.fpcResult.data.irrigated_projected', function() {
              return _this.autoSetPowerSourceAmount();
            });
            _this.scope.$watch('service.fpcResult.data.irrigated_actual', function() {
              return _this.autoSetPowerSourceAmount();
            });
            return _this.scope.$watch('service.fpcResult.data.drying_system', function(newValue, oldValue) {
              if ((newValue != null) && newValue !== oldValue) {
                _this.autoSetPowerSource();
              }
              return _this.autoSetPowerSourceAmount();
            });
          });
        };
      })(this));
      this.scope.$watch('service.fpcResult.data.moisture_difference', (function(_this) {
        return function(value) {
          if (value == null) {
            return;
          }
          if (value > 21) {
            _this.service.fpcResult.data.moisture_difference = 21;
            return;
          }
          if (value < 0) {
            _this.service.fpcResult.data.moisture_difference = 0;
            return;
          }
          return _this.service.fpcResult.data.moisture_difference = parseInt(value);
        };
      })(this));
    }

    DryingController.prototype.autoSetPowerSource = function() {
      var newPowerSource, ref;
      newPowerSource = (ref = this.dryingSystems[this.service.fpcResult.data.drying_system]) != null ? ref.source : void 0;
      if (newPowerSource) {
        return this.service.fpcResult.data.power_source = newPowerSource;
      }
    };

    DryingController.prototype.autoSetPowerSourceAmount = function() {
      var newPowerSourceAmount;
      if (this.service.fpcResult.data.manual_power_source_amount && this.service.fpcResult.data.power_source_amount) {
        return;
      }
      if (!this.service.fpcResult.data.power_source_amount) {
        this.service.fpcResult.data.manual_power_source_amount = false;
      }
      newPowerSourceAmount = this.calculatePowerSourceAmount();
      if (newPowerSourceAmount) {
        return this.service.fpcResult.data.power_source_amount = parseFloat(newPowerSourceAmount.toFixed(2));
      } else {
        return this.service.fpcResult.data.power_source_amount = null;
      }
    };

    DryingController.prototype.calculatePowerSourceAmount = function() {
      var bushels, coefficient, dryingSystemType, drylandYieldToUse, irrigatedYieldToUse, map, moistureDifference, powerIsElectricity, powerSource, ref;
      powerSource = this.service.fpcResult.data.power_source;
      moistureDifference = this.service.fpcResult.data.moisture_difference;
      dryingSystemType = (ref = this.dryingSystems[this.service.fpcResult.data.drying_system]) != null ? ref.type : void 0;
      if (this.service.fpcResult.data.irrigated) {
        map = this.service.fpcResult.irrigation_map;
        if (this.service.fpcResult.data.yield_to_use === 'projected') {
          irrigatedYieldToUse = this.service.fpcResult.data.irrigated_projected;
          drylandYieldToUse = this.service.fpcResult.data.dryland_projected;
        } else {
          irrigatedYieldToUse = this.service.fpcResult.data.irrigated_actual;
          drylandYieldToUse = this.service.fpcResult.data.dryland_actual;
        }
        bushels = _(map.areas).filter({
          value: 'Irrigated'
        }).sumBy('acres') * irrigatedYieldToUse;
        bushels += _(map.areas).filter({
          value: 'Dryland'
        }).sumBy('acres') * drylandYieldToUse;
      } else {
        bushels = this.fieldArea * this.service.fpcResult.data.dryland_projected;
      }
      if (!(powerSource && bushels && moistureDifference)) {
        return null;
      }
      powerIsElectricity = ['Electricity - Grid', 'Electricity - Solar', 'Electricity - Wind'].includes(powerSource);
      if (powerSource !== 'Propane, LPG' && !powerIsElectricity && powerSource !== 'Natural Gas') {
        return null;
      }
      coefficient = (function() {
        switch (dryingSystemType) {
          case 'natural':
            switch (powerSource) {
              case 'Propane, LPG':
                return 0;
              case 'Electricity - Grid':
                return 0.2531;
              case 'Electricity - Solar':
                return 0.2531;
              case 'Electricity - Wind':
                return 0.2531;
              default:
                return 0;
            }
            break;
          case 'low':
            switch (powerSource) {
              case 'Propane, LPG':
                return 0.0068;
              case 'Electricity - Grid':
                return 0.1582;
              case 'Electricity - Solar':
                return 0.1582;
              case 'Electricity - Wind':
                return 0.1582;
              default:
                return null;
            }
            break;
          case 'stirred':
            switch (powerSource) {
              case 'Propane, LPG':
                return 0.0159;
              case 'Electricity - Grid':
                return 0.0076;
              case 'Electricity - Solar':
                return 0.0076;
              case 'Electricity - Wind':
                return 0.0076;
              default:
                return null;
            }
            break;
          case 'continuous':
            switch (powerSource) {
              case 'Propane, LPG':
                return 0.0159;
              case 'Electricity - Grid':
                return 0.0076;
              case 'Electricity - Solar':
                return 0.0076;
              case 'Electricity - Wind':
                return 0.0076;
              default:
                return null;
            }
            break;
          case 'recirculating':
            switch (powerSource) {
              case 'Propane, LPG':
                return 0.0173;
              case 'Electricity - Grid':
                return 0.0169;
              case 'Electricity - Solar':
                return 0.0169;
              case 'Electricity - Wind':
                return 0.0169;
              default:
                return 1.6121;
            }
            break;
          case 'no-recirculating':
            switch (powerSource) {
              case 'Propane, LPG':
                return 0.0221;
              case 'Electricity - Grid':
                return 0.0105;
              case 'Electricity - Solar':
                return 0.0105;
              case 'Electricity - Wind':
                return 0.0105;
              default:
                return 2.0593;
            }
        }
      })();
      return coefficient * bushels * moistureDifference;
    };

    return DryingController;

  })(Controller);

}).call(this);
